<template>
  <div class="app-content-wrapper batch-view-wrapper">
    <div class="batch-title">{{$t('message.settlement.batchNo')}}</div>
    <div class="batch-no">{{$route.query.settleBatchNo}}</div>
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :search-buttons="searchButtonList"
                        :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
                        router-name="/wallet/balance/batch/view">

      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    :service-function="getSettlementDetailList"
                    :first-parameters="isBatchSearch?{}:getInitParams()"
                    :is-first-automatic-visit="false"
                    ref="table"
                    router-name="/wallet/balance/batch/view">
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>

import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { getTodayParams, initToday } from '@/utils/tools/time';
import SettlementDetailsService from '@/views/settlement/api/settlement-details';

export default {
  components: {
    SearchComponent,
    CustomTable,
    CustomMessage,
  },
  data() {
    return {
      getTodayParams,
      ...SettlementDetailsService,
      isBatchSearch: false,
      txnTypeList: [],
      txnStatusList: [],
      cardTypeList: [],
      feeStatusList: [],
      settleStatusList: [],
      websiteTypeList: [],
      downloading: false,
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.txnSerialNumber')};${this.$t('message.tableCommon.merchantOrderNumber')}`,
      searchCondition: [
        {
          key: ['startTime', 'endTime'],
          name: 'message.settlement.time',
          defValue: initToday(),
          type: 'date_time',
        },
        {
          key: ['txnStartTimes', 'txnEndTimes'],
          name: 'message.settlement.txnTime',
          // defValue: initToday(),
          type: 'date_time',
        },
        // {
        //   key: 'externalOrderId',
        //   name: 'message.tableCommon.merchantOrderNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        {
          key: 'productType',
          name: 'message.tableCommon.productType',
          type: 'select',
          defValue: '',
        },
        {
          key: 'txnType',
          name: 'message.tableCommon.txnType',
          type: 'select',
          defValue: '',
          options: this.txnTypeList,
        },
        {
          key: 'txnStatus',
          name: 'message.tableCommon.txnStatus',
          type: 'select',
          defValue: '',
        },
        {
          key: 'settleBatchNo',
          name: 'message.settlement.batchNo',
          type: 'input',
          defValue: this.$route.query.settleBatchNo,
          isHide: true,
        },
        // {
        //   key: 'cardType',
        //   name: 'message.tableCommon.cardType',
        //   type: 'select',
        //   defValue: '',
        // },
        // {
        //   key: 'feeStatus',
        //   name: 'message.settlement.feeStatus',
        //   type: 'select',
        //   defValue: '',
        // },
        // {
        //   key: 'settleStatus',
        //   name: 'message.settlement.settlementStatus',
        //   type: 'select',
        //   defValue: '',
        // },
      ],
      searchButtonList: [
        {
          type: 'download',
          // permissionCode: 'settlement:details:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await this.downloadSettlementDetail(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        }],
      tableCondition: [
        { // 结算日期
          titleBar: { type: 'text', title: 'message.settlement.time' },
          key: 'settleDate',
          type: 'text',
        },
        { // 交易时间
          titleBar: { type: 'text', title: 'message.settlement.txnTime' },
          key: 'txnTime',
          type: 'text',
        },
        { // 结算批次号
          titleBar: { type: 'text', title: 'message.settlement.batchNo' },
          key: 'settleBatchNo',
          type: 'text',
        },
        { // 交易流水号
          titleBar: { type: 'text', title: 'message.tableCommon.txnSerialNumber' },
          key: 'serviceId',
          type: 'text',
        },
        // APPID
        {
          titleBar: { type: 'text', title: 'message.settlement.appId' },
          key: 'appId',
          type: 'text',
          itemMinWidth: 170,
        },
        // 网址
        {
          titleBar: { type: 'text', title: 'message.settlement.transactionUrl' },
          key: 'txnWebsite',
          type: 'text',
          itemMinWidth: 170,
        },
        { // 商户订单号
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOrderNumber' },
          key: 'externalOrderId',
          type: 'text',
        },
        { // 产品类型
          titleBar: { type: 'text', title: 'message.tableCommon.productType' },
          key: 'productTypeName',
          type: 'text',
        },
        { // 卡种
          titleBar: { type: 'text', title: 'message.tableCommon.cardType' },
          key: 'cardType',
          type: 'text',
        },
        { // 子卡种
          titleBar: { type: 'text', title: 'message.tableCommon.subCardType' },
          key: 'walletTypeCode',
          type: 'text',
        },
        { // 下单金额
          titleBar: { type: 'text', title: 'message.tableCommon.orderAmount' },
          key: 'orderAmount',
          type: 'text',
          textFunc: (data) => `${data.orderAmount}${data.orderCurrency}`,
        },
        { // 交易类型
          titleBar: { type: 'text', title: 'message.tableCommon.txnType' },
          key: 'txnType',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
        },
        { // 交易状态
          titleBar: { type: 'text', title: 'message.tableCommon.txnStatus' },
          key: 'txnStatus',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnStatusList, data.txnStatus),
        },
        { // 交易金额
          titleBar: { type: 'text', title: 'message.tableCommon.txnAmount' },
          key: 'txnAmount',
          type: 'text',
          textFunc: (data) => `${data.txnAmount}${data.settleCurrency}`,
          // textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
        },
        { // 平台类型
          titleBar: { type: 'text', title: 'message.tableCommon.platformType' },
          key: 'websiteType',
          type: 'text',
          textFunc: (data) => {
            if (`${data.websiteType}` === '0') {
              return this.$t('message.common.unlimited');
            }
            return getEnantiomericValue(this.websiteTypeList, data.websiteType);
          },
        },
        { // 处理费
          titleBar: { type: 'text', title: 'message.settlement.handlingAmount' },
          key: 'handlingAmount',
          type: 'text',
        },
        { // 手续费
          titleBar: { type: 'text', title: 'message.settlement.serviceAmount' },
          key: 'feeAmount',
          type: 'text',
        },
        { // 保证金
          titleBar: { type: 'text', title: 'message.settlement.deposit' },
          key: 'depositAmount',
          type: 'text',
        },
        { // Scheme Fee
          titleBar: { type: 'text', title: 'message.tableCommon.schemeAmt' },
          key: 'schemeAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.schemeAmount && data.schemeAmount.currency, data.schemeAmount && data.schemeAmount.amount),
        },
        { // Interchange Fee
          titleBar: { type: 'text', title: 'message.tableCommon.interchangeAmt' },
          key: 'interchangeAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.interchangeAmount && data.interchangeAmount.currency, data.interchangeAmount && data.interchangeAmount.amount),
        },
        { // Markup
          titleBar: { type: 'text', title: 'message.tableCommon.markupAmt' },
          key: 'markupAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.markupAmount && data.markupAmount.currency, data.markupAmount && data.markupAmount.amount),
        },
        // { // 税费
        //   titleBar: { type: 'text', title: 'message.tableCommon.taxes' },
        //   key: 'taxes',
        //   type: 'text',
        //   textFunc: (data) => splicingAmountAndCurrency(data.taxes && data.taxes.currency, data.taxes && data.taxes.amount),
        // },
        { // 平台费
          titleBar: { type: 'text', title: 'message.tableCommon.platformFee' },
          key: 'platformFeeAmount',
          type: 'text',
        },
        { // 结算金额
          titleBar: { type: 'text', title: 'message.settlement.settlementAmount' },
          key: 'sumAmount',
          type: 'text',
        },
        { // 结算币种
          titleBar: { type: 'text', title: 'message.settlement.currency' },
          key: 'settleCurrency',
          type: 'text',
        },
        // { // 计费状态
        //   titleBar: { type: 'text', title: 'message.settlement.feeStatus' },
        //   key: 'feeStatusName',
        //   type: 'text',
        //   textFunc: (data) => getEnantiomericValue(this.feeStatusList, data.feeStatus),
        // },
        // { // 结算状态
        //   titleBar: { type: 'text', title: 'message.settlement.settlementStatus' },
        //   key: 'settleStatusName',
        //   type: 'text',
        //   textFunc: (data) => getEnantiomericValue(this.settleStatusList, data.settleStatus),
        // },
      ],
    };
  },
  methods: {
    getInitParams() {
      return {
        ...getTodayParams('startTime', 'endTime'),
        // ...getTodayParams('txnStartTimes', 'txnEndTimes'),
      };
    },
    validSearchParams(params) {
      if (params.keywords) { // 存在交易流水号，则不校验时间
        return true;
      }
      if (!params.startTime && !params.endTime && !params.txnStartTimes && !params.txnEndTimes) {
        ShowErrorMessage(this.$t('message.settlement.searchTimeTip'));
        return false;
      }
      if (params.startTime || params.endTime) {
        if (!params.startTime) {
          ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.settlement.time') }));
          return false;
        }
        if (!params.endTime) {
          ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.settlement.time') }));
          return false;
        }
      }

      if (params.txnStartTimes || params.txnEndTimes) {
        if (!params.txnStartTimes) {
          ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.settlement.txnTime') }));
          return false;
        }
        if (!params.txnEndTimes) {
          ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.settlement.txnTime') }));
          return false;
        }
      }

      return true;
    },
    async initMethod() {
      await GlobalData.getDictList(['CREDIT_CARD_TYPE', 'FEE_STATUS', 'MERC_SETTLE_STATUS', 'PRODUCT_TYPE',
        'TXN_TYPE', 'TXN_STATUS', 'WEB_TYPE']).then((res) => {
        this.$refs.search.setSearchSelectOptions('productType',
          initSelectedData(res.PRODUCT_TYPE));
        this.txnTypeList = initSelectedData(res.TXN_TYPE);
        this.txnStatusList = initSelectedData(res.TXN_STATUS);
        this.cardTypeList = initSelectedData(res.CREDIT_CARD_TYPE);
        this.feeStatusList = initSelectedData(res.FEE_STATUS);
        this.settleStatusList = initSelectedData(res.MERC_SETTLE_STATUS);
        this.websiteTypeList = initSelectedData(res.WEB_TYPE);
        // this.$refs.search.setSearchSelectOptions('cardType', this.cardTypeList);
        this.$refs.search.setSearchSelectOptions('txnType', this.txnTypeList);
        this.$refs.search.setSearchSelectOptions('txnStatus', this.txnStatusList);
        // this.$refs.search.setSearchSelectOptions('settleStatus', this.settleStatusList);
        // this.$refs.search.setSearchSelectOptions('feeStatus', this.feeStatusList);
      }).catch(() => {
      });

      this.$refs.table.firstVisitHttp();
    },
  },
  mounted() {
    this.initMethod();
    if (this.$route.query.settleBatchNo) {
      this.$refs.search.setInputValue('startTime', '');
      this.$refs.search.setInputValue('endTime', '');
      this.$refs.search.setInputValue('txnStartTimes', '');
      this.$refs.search.setInputValue('txnEndTimes', '');
    }
  },
  created() {
    if (this.$route.query.settleBatchNo) {
      this.isBatchSearch = true;
    }
  },
};
</script>
<style  lang="scss">
.batch-view-wrapper {
  .batch-title {
    font-size: 14px;
    font-weight: normal;
    line-height: 32px;
  }
  .batch-no {
    font-size: 26px;
    font-weight: 800;
    line-height: 36px;
    margin-top: 4px;
  }
  .search-wrapper {
    padding-top: 32px;
  }
}
#refundDetail .is-bordered-label{
  width: 50%;
}
</style>
